var map = {
	"./anxiang/donation.png": "Epxz",
	"./default/donation.png": "+y+v",
	"./huarong/donation.png": "tvQz",
	"./master/donation.png": "0wuI",
	"./shaodong/donation.png": "VCbm",
	"./taoyuan/donation.png": "l1CC",
	"./yueyang/donation.png": "Fl2T",
	"./zhuzhou/donation.png": "ed7g"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EIxw";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/donation\.png$
// module id = EIxw
// module chunks = 1